<script setup lang="ts">
defineProps<{
  label: string
}>()
</script>

<template>
  <label class="default-label">{{ label }}</label>
</template>

<style scoped lang="scss">
.default-label {
  font-weight: bold;
}
</style>
